export const audioStatuses = {
  empty: 'Empty',
  loading: 'Loading',
  ready: 'Ready',
  play: 'Play',
  pause: 'Pause'
}
